// Pure planning for Remote End of Day (remote_eod_controller.js): which files in
// the chosen folder get sent, under what path, and in what batches. Kept apart
// from the controller so it is tested without a browser.

// Windows and macOS litter; never part of a job.
const JUNK = new Set(["thumbs.db", "desktop.ini", ".ds_store"])

const sameScode = (a, b) => String(a).replace(/^0+/, "") === String(b).replace(/^0+/, "")

// A file's path inside the school folder, from the browser's webkitRelativePath.
// The photographer may pick the school folder (C:\Jobs2027\383) or the season
// folder above it (C:\Jobs2027); either way the path is taken from INSIDE the
// school folder, which is what the laptop's End of Day copies. Anything outside
// that school's folder is not this job's and is left out (null).
export function pathInSchool(relativePath, scode) {
  const parts = String(relativePath || "").split("/").filter(Boolean)
  if (parts.length < 2) return null

  if (sameScode(parts[0], scode)) return parts.slice(1).join("/")
  if (parts.length > 2 && sameScode(parts[1], scode)) return parts.slice(2).join("/")
  return null
}

export function isJunk(path) {
  const name = path.split("/").pop().toLowerCase()
  return JUNK.has(name) || name.startsWith("~$")
}

// [{ path, file }] for every usable file in the picked folder.
export function folderEntries(files, scode) {
  return Array.from(files)
    .map((file) => ({ path: pathInSchool(file.webkitRelativePath, scode), file }))
    .filter(({ path }) => path && !isJunk(path))
}

// The entries S3 doesn't already hold at the same size -- what a rerun still
// has to send.
export function stillToSend(entries, existingSizes) {
  return entries.filter(({ path, file }) => existingSizes[path] !== file.size)
}

export function batches(items, size) {
  const out = []
  for (let i = 0; i < items.length; i += size) out.push(items.slice(i, i + size))
  return out
}

export function formatBytes(bytes) {
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(2)} GB`
  if (bytes >= 1e6) return `${(bytes / 1e6).toFixed(1)} MB`
  if (bytes >= 1e3) return `${Math.round(bytes / 1e3)} KB`
  return `${bytes} B`
}
